import React from 'react';
import { Vehicle } from 'core/models/vehicle';
import { Project } from 'core/models/project';
import { Environment } from 'core/models/environment';
import { Widget } from 'components/views/molecules/Widget';
import { VehicleMonitor } from 'components/containers/common/VehicleMonitor';

export type VehicleMonitorWidgetProps = {
    vehicle: Vehicle;
    projectId: Project.Id;
    environmentId: Environment.Id;
    onTitleClick: () => void;
}

export const VehicleMonitorWidget = (props: VehicleMonitorWidgetProps) => {
    const { vehicle, projectId, environmentId, onTitleClick } = props;

    function unsupportedButtonClicked() {
        throw new Error('unimplemented button clicked');
    }

    return (
        <Widget
            title={`Vehicle ${vehicle.name}`}
            onTitleClick={onTitleClick}
            onSettingButtonClick={unsupportedButtonClicked}>
            <VehicleMonitor vehicleId={vehicle.id} projectId={projectId} environmentId={environmentId} viewOnly={true} />
        </Widget>
    );
};
